export const USER_POST_CREATE_REQUEST = "USER_POST_CREATE_REQUEST"
export const USER_POST_CREATE_SUCCESS = "USER_POST_CREATE_SUCCESS"
export const USER_POST_CREATE_FAIL = "USER_POST_CREATE_FAIL"
export const USER_POST_RESET = "USER_POST_RESET"

export const GET_USER_POST_REQUEST = "GET_USER_POST_REQUEST"
export const GET_USER_POST_SUCCESS = "GET_USER_POST_SUCCESS"
export const GET_USER_POST_FAIL = "GET_USER_POST_FAIL"

export const USER_LIKE_POST_REQUEST = "USER_LIKE_POST_REQUEST"
export const USER_LIKE_POST_SUCCESS = "USER_LIKE_POST_SUCCESS"
export const USER_LIKE_POST_FAIL = "USER_LIKE_POST_FAIL"

export const USER_RETWEET_POST_REQUEST = "USER_RETWEET_POST_REQUEST"
export const USER_RETWEET_POST_SUCCESS = "USER_RETWEET_POST_SUCCESS"
export const USER_RETWEET_POST_FAIL = "USER_RETWEET_POST_FAIL"

export const GET_POSTBYID_REQUEST = "GET_POSTBYID_REQUEST"
export const GET_POSTBYID_SUCCESS = "GET_POSTBYID_SUCCESS"
export const GET_POSTBYID_FAIL = "GET_POSTBYID_FAIL"

export const USER_REPLY_CREATE_REQUEST = "USER_REPLY_CREATE_REQUEST"
export const USER_REPLY_CREATE_SUCCESS = "USER_REPLY_CREATE_SUCCESS"
export const USER_REPLY_CREATE_FAIL = "USER_REPLY_CREATE_FAIL"

export const DELETE_POSTBYID_REQUEST = "DELETE_POSTBYID_REQUEST"
export const DELETE_POSTBYID_SUCCESS = "DELETE_POSTBYID_SUCCESS"
export const DELETE_POSTBYID_FAIL = "DELETE_POSTBYID_FAIL"

export const PIN_POSTBYID_REQUEST = "PIN_POSTBYID_REQUEST"
export const PIN_POSTBYID_SUCCESS = "PIN_POSTBYID_SUCCESS"
export const PIN_POSTBYID_FAIL = "PIN_POSTBYID_FAIL"

export const POST_SEARCH_REQUEST = "POST_SEARCH_REQUEST"
export const POST_SEARCH_SUCCESS = "POST_SEARCH_SUCCESS"
export const POST_SEARCH_FAIL = "POST_SEARCH_FAIL"


